"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const callableTakePhoto = ({ processor, functionId, callbacks, executeProcesses, }) => {
    const onTake = (uri) => {
        processor.root.openCamera({ isOpened: false, onTakePicture: undefined });
        if (uri) {
            executeProcesses(functionId, callbacks.onTake, uri);
        }
    };
    const onClose = () => {
        executeProcesses(functionId, callbacks.onCancel);
        processor.root.openCamera({ isOpened: false });
    };
    const onRejectedPermissions = () => {
        executeProcesses(functionId, callbacks.onRejectedPermissions);
        processor.root.openCamera({ isOpened: false });
    };
    processor.root.openCamera({
        isOpened: true,
        onTakePicture: onTake,
        onClose,
        onRejectedPermissions,
    });
};
exports.default = callableTakePhoto;
